define("shared/components/shared/post/secondary/publishing-method-setup/notification-setup/index", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "ember-concurrency", "later/utils/object-promise-proxy", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _emberConcurrency, _objectPromiseProxy, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"later/utils/object-promise-proxy",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.hasDevices}}
    {{! Test Notification }}
    <Shared::Post::Secondary::PublishingMethodSetup::Layout
      @image="/assets/images/img--nonPublishedPosts--enable__push__notifications.png"
      @title={{t "onboarding.side_wiz.general.set_up_notification_publishing.heading2"}}
    >
      <:body>
        <p>{{t "onboarding.side_wiz.general.set_up_notification_publishing.subcopy2_1"}}</p>
        <p>{{t "onboarding.side_wiz.general.set_up_notification_publishing.subcopy2_2"}}</p>
      </:body>
      <:footer>
        <Shared::Ui::Button
          @additional="block"
          @text={{t "onboarding.side_wiz.general.set_up_notification_publishing.btn_send_test"}}
          @variant="outline"
          {{on "click" this.testNotification}}
        />
        <Shared::Ui::Button
          @additional="block"
          @text={{t "onboarding.side_wiz.general.set_up_notification_publishing.btn_complete"}}
          @variant="primary"
          {{on "click" (perform this.complete)}}
        />
      </:footer>
    </Shared::Post::Secondary::PublishingMethodSetup::Layout>
  {{else}}
    {{! Setup Device }}
    <Shared::Post::Secondary::PublishingMethodSetup::Layout
      @image="/assets/images/img--nonPublishedPosts--download__mobile__app.png"
      @title={{html-safe (t "onboarding.side_wiz.general.set_up_notification_publishing.heading")}}
    >
      <:body>
        <div class="u--m__b__md">
          <p>{{t "onboarding.side_wiz.general.set_up_notification_publishing.subcopy1"}}</p>
          <ol class="u--p__l__md u--m__tb">
            <li class="u--p__tb__xs u--p__lr__0">
              {{html-safe (t "onboarding.side_wiz.general.set_up_notification_publishing.step1")}}
            </li>
            <li class="u--p__tb__xs u--p__lr__0">
              {{html-safe
                (t "onboarding.side_wiz.general.set_up_notification_publishing.step2" email=this.accountOwnerEmail)
              }}
            </li>
          </ol>
          <Shared::Link @href="https://help.later.com/hc/articles/360043244813" @text={{t "shared_phrases.learn_more"}} />
        </div>
        <Shared::AppstoreLinks @origin="onboarding" />
      </:body>
      <:footer>
        <Shared::Ui::Button
          @additional="block"
          @text={{t "onboarding.side_wiz.general.cancel"}}
          @variant="outline"
          class="qa--notificationSetup_cancel_btn"
          {{on "click" @handleClose}}
        />
        <div class="cPM--secondary__loaderWrapper">
          <div class="o--loading cPM--secondary__loader"></div>
          <span class="u--text--sm u--m__l__xs qa--setup_mobile_signin_prompt">
            {{html-safe (t "onboarding.side_wiz.general.set_up_notification_publishing.loading")}}
          </span>
        </div>
      </:footer>
    </Shared::Post::Secondary::PublishingMethodSetup::Layout>
  {{/if}}
  */
  {
    "id": "dWiXwn0t",
    "block": "[[[41,[30,0,[\"hasDevices\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@image\",\"@title\"],[\"/assets/images/img--nonPublishedPosts--enable__push__notifications.png\",[28,[37,2],[\"onboarding.side_wiz.general.set_up_notification_publishing.heading2\"],null]]],[[\"body\",\"footer\"],[[[[1,\"\\n      \"],[10,2],[12],[1,[28,[35,2],[\"onboarding.side_wiz.general.set_up_notification_publishing.subcopy2_1\"],null]],[13],[1,\"\\n      \"],[10,2],[12],[1,[28,[35,2],[\"onboarding.side_wiz.general.set_up_notification_publishing.subcopy2_2\"],null]],[13],[1,\"\\n    \"]],[]],[[[1,\"\\n      \"],[8,[39,3],[[4,[38,4],[\"click\",[30,0,[\"testNotification\"]]],null]],[[\"@additional\",\"@text\",\"@variant\"],[\"block\",[28,[37,2],[\"onboarding.side_wiz.general.set_up_notification_publishing.btn_send_test\"],null],\"outline\"]],null],[1,\"\\n      \"],[8,[39,3],[[4,[38,4],[\"click\",[28,[37,5],[[30,0,[\"complete\"]]],null]],null]],[[\"@additional\",\"@text\",\"@variant\"],[\"block\",[28,[37,2],[\"onboarding.side_wiz.general.set_up_notification_publishing.btn_complete\"],null],\"primary\"]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,1],null,[[\"@image\",\"@title\"],[\"/assets/images/img--nonPublishedPosts--download__mobile__app.png\",[28,[37,6],[[28,[37,2],[\"onboarding.side_wiz.general.set_up_notification_publishing.heading\"],null]],null]]],[[\"body\",\"footer\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"u--m__b__md\"],[12],[1,\"\\n        \"],[10,2],[12],[1,[28,[35,2],[\"onboarding.side_wiz.general.set_up_notification_publishing.subcopy1\"],null]],[13],[1,\"\\n        \"],[10,\"ol\"],[14,0,\"u--p__l__md u--m__tb\"],[12],[1,\"\\n          \"],[10,\"li\"],[14,0,\"u--p__tb__xs u--p__lr__0\"],[12],[1,\"\\n            \"],[1,[28,[35,6],[[28,[37,2],[\"onboarding.side_wiz.general.set_up_notification_publishing.step1\"],null]],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"li\"],[14,0,\"u--p__tb__xs u--p__lr__0\"],[12],[1,\"\\n            \"],[1,[28,[35,6],[[28,[37,2],[\"onboarding.side_wiz.general.set_up_notification_publishing.step2\"],[[\"email\"],[[30,0,[\"accountOwnerEmail\"]]]]]],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,7],null,[[\"@href\",\"@text\"],[\"https://help.later.com/hc/articles/360043244813\",[28,[37,2],[\"shared_phrases.learn_more\"],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,8],null,[[\"@origin\"],[\"onboarding\"]],null],[1,\"\\n    \"]],[]],[[[1,\"\\n      \"],[8,[39,3],[[24,0,\"qa--notificationSetup_cancel_btn\"],[4,[38,4],[\"click\",[30,1]],null]],[[\"@additional\",\"@text\",\"@variant\"],[\"block\",[28,[37,2],[\"onboarding.side_wiz.general.cancel\"],null],\"outline\"]],null],[1,\"\\n      \"],[10,0],[14,0,\"cPM--secondary__loaderWrapper\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"o--loading cPM--secondary__loader\"],[12],[13],[1,\"\\n        \"],[10,1],[14,0,\"u--text--sm u--m__l__xs qa--setup_mobile_signin_prompt\"],[12],[1,\"\\n          \"],[1,[28,[35,6],[[28,[37,2],[\"onboarding.side_wiz.general.set_up_notification_publishing.loading\"],null]],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]]]],[\"@handleClose\"],false,[\"if\",\"shared/post/secondary/publishing-method-setup/layout\",\"t\",\"shared/ui/button\",\"on\",\"perform\",\"html-safe\",\"shared/link\",\"shared/appstore-links\"]]",
    "moduleName": "shared/components/shared/post/secondary/publishing-method-setup/notification-setup/index.hbs",
    "isStrictMode": false
  });
  let NotificationSetupComponent = _exports.default = (_class = class NotificationSetupComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "segment", _descriptor4, this);
      _defineProperty(this, "complete", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.segment.track('connected-mobile-onboarding');
          const socialProfiles = yield (0, _objectPromiseProxy.default)(this.auth.currentGroup.socialProfiles);
          if (socialProfiles.length > 1) {
            for (const socialProfile of socialProfiles.toArray()) {
              yield socialProfile.get('refreshAndReload').perform();
            }
          } else {
            yield this.args.socialProfile.get('refreshAndReload').perform();
          }
          this.alerts.success(this.intl.t('onboarding.side_wiz.general.set_up_notification_publishing.success_banner_text'), {
            title: this.intl.t('onboarding.side_wiz.general.set_up_notification_publishing.success_banner_title')
          });
          return this.args.handleClose();
        }
      }), null, "complete", null));
    }
    get accountOwnerEmail() {
      return this.auth.currentUserModel.email;
    }
    get hasDevices() {
      return this.auth.hasDevices;
    }
    get firstDevice() {
      return this.auth.devices.firstObject;
    }
    testNotification() {
      this.segment.track('tested-mobile-notification-onboarding');
      this.firstDevice.testNotification().then(() => {
        this.alerts.success(this.intl.t('alerts.account.devices.test_notification.success.message'), {
          timeout: 5000,
          title: this.intl.t('alerts.account.devices.test_notification.success.title')
        });
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "testNotification", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "testNotification"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, NotificationSetupComponent);
});